import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

import * as viewmodels from 'app/viewmodels';

@Component({
    selector: 'app-template-grid',
    templateUrl: './template-grid.component.html',
    styleUrls: ['./template-grid.component.scss'],
    standalone: false
})
export class TemplateGridComponent implements OnChanges {

  @Input() templates: viewmodels.TemplateListViewModel[];
  @Input() gridTitle: string;
  @Input() selectedTemplate: string;
  @Input() tooltipContent: string;
  @Input() displayHarvestsCreated: boolean = true;
  @Input() itemNoun: string = 'template';
  @Input() loading: boolean = false;

  /** Flat rows for the p-table, rebuilt whenever the templates input changes. */
  tableRows: Array<any> = [];

  constructor(
    private router: Router
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.templates != null){
      this.buildTableRows();
    }
  }

  buildTableRows() {
    this.tableRows = (this.templates || []).map(t => ({ ...t }));
  }

  get totalColumnCount(): number {
    return this.displayHarvestsCreated ? 5 : 4;
  }

  openTemplate(row: any) {
    if (row?.id) {
      this.router.navigate(['console', 'template', row.id]);
    }
  }

  exportAsCSV() {
    const cols: Array<{ header: string, value: (r: any) => string }> = [
      { header: 'Name', value: r => r.name ?? '' },
      { header: 'Phases', value: r => (r.phases != null ? String(r.phases) : '') },
      { header: 'Events', value: r => (r.events != null ? String(r.events) : '') },
    ];
    if (this.displayHarvestsCreated) {
      cols.push({ header: 'Harvests Created', value: r => (r.harvestsCreated != null ? String(r.harvestsCreated) : '') });
    }
    cols.push({ header: 'Duration (Days)', value: r => (r.duration != null ? String(r.duration) : '') });

    const esc = (s: any) => '"' + String(s ?? '').replace(/"/g, '""') + '"';
    const lines = [cols.map(c => esc(c.header)).join(',')];
    this.tableRows.forEach(r => lines.push(cols.map(c => esc(c.value(r))).join(',')));

    const blob = new Blob([lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${this.itemNoun}s.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }
}
